import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import useAos from '../hooks/useAos';
import { PageMeta } from '../seo/PageMeta';

const SERVICE_IDS = ['batiment', 'industriel', 'municipal', 'gestion-de-projets', 'autres'];

function Service() {
    const navigate = useNavigate();
    const { t } = useTranslation(['pages', 'common']);
    const [openServices, setOpenServices] = useState({});

    const toggleService = (index) => {
        setOpenServices((prev) => ({ ...prev, [index]: !prev[index] }));
    };

    return (
        <div>
            <div className="flex flex-column bg-gray items-center justify-center py-64 px-64 overflow-hidden w-full" data-navbar-theme="dark">
                <div className="overflow-hidden w-full">
                    <h1 className="text-title2 text-center t-white fustat text-semibold m-0 py-64" data-aos="fade-up">{t('pages:services.heading')}</h1>
                </div>
                <div className="flex flex-column gap-32 items-center w-full">
                    {SERVICE_IDS.map((serviceId, index) => {
                        const isOpen = !!openServices[index];
                        const sections = t(`pages:services.items.${serviceId}.sections`, { returnObjects: true });

                        return (
                            <div
                                key={serviceId}
                                className="w-full"
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                            >
                                <div className="service-box flex flex-column items-center justify-center border-graylight p-32 w-full">
                                    <h2 id={serviceId} className={`service-anchor text-title3 text-center t-white fustat text-semibold m-0 ${isOpen ? 'mb-32' : ''}`}>
                                        {t(`pages:services.items.${serviceId}.title`)}
                                    </h2>
                                    {Array.isArray(sections) && sections.length > 0 && (
                                        <>
                                            <div className={`service-section-collapse w-full ${isOpen ? 'is-open' : ''}`}>
                                                <div className="service-section-collapse__inner">
                                                    <div className="flex flex-column items-center justify-center w-full">
                                                        {sections.map((section, sectionIndex) => (
                                                            <p
                                                                key={sectionIndex}
                                                                className={`service-section-item text-subtitle text-center t-white outfit text-light m-0 ${
                                                                    sectionIndex === 0 ? 'service-section-item--first' : ''
                                                                }`}
                                                            >
                                                                {section}
                                                            </p>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                className="btn-light-white mt-32"
                                                onClick={() => toggleService(index)}
                                            >
                                                {isOpen ? t('common:buttons.seeLess') : t('common:buttons.learnMore')}
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="flex flex-column items-center justify-center service-cta-section overflow-hidden w-full" data-navbar-theme="light">
                <p className="text-subtitle text-center t-bluelink fustat text-regular mt-0 mb-32" data-aos="fade-up">{t('pages:services.ourProjects')}</p>
                <p className="text-title3 text-center fustat text-semibold mt-0 mb-32" data-aos="fade-up" data-aos-delay="150">{t('pages:services.inActionTitle')}</p>
                <p className="text-subtitle2 outfit text-center t-graymid text-regular my-0 w-50 mb-32" data-aos="fade-up" data-aos-delay="300">{t('pages:services.inActionText')}</p>
                <div data-aos="fade-up" data-aos-delay="450" className="w-50">
                    <button type="button" onClick={() => navigate('/realisations')} className="btn-blue w-full flex items-center justify-center gap-16"><span>{t('common:buttons.seeProjects')}</span> <FontAwesomeIcon icon={faAngleRight} /></button>
                </div>
            </div>
        </div>
    );
}

export default function ServicePage() {
    useAos();
    const { t } = useTranslation('pages');

    return (
        <>
            <PageMeta
                title={t('meta.services.title')}
                description={t('meta.services.description')}
                path="/services"
            />
            <Navbar />
            <Service />
            <Footer />
        </>
    );
}
